import { SvgIcon, SxProps } from "@mui/material";
import SvgReportIcon from "jsx:../../../Images/Icons/FontAwesome/light/flag.svg";

export function ReportIcon(props: SxProps) {
    return <SvgIcon component={SvgReportIcon} inheritViewBox sx={props} />;
}
